var travelModes = {
    "Car Time": {
        "attributeParameterValues": [
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Avoid Unpaved Roads",
        "value": "AVOID_HIGH"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Avoid Private Roads",
        "value": "AVOID_MEDIUM"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Driving an Automobile",
        "value": "PROHIBITED"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Through Traffic Prohibited",
        "value": "AVOID_HIGH"
        },
        {
        "parameterName": "Vehicle Maximum Speed (km/h)",
        "attributeName": "TravelTime",
        "value": 0
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Roads Under Construction Prohibited",
        "value": "PROHIBITED"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Avoid Gates",
        "value": "AVOID_MEDIUM"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Avoid Express Lanes",
        "value": "PROHIBITED"
        },
        {
        "parameterName": "Restriction Usage",
        "attributeName": "Avoid Carpool Roads",
        "value": "PROHIBITED"
        }
        ],
        "description": "Models the movement of cars and other similar small automobiles, such as pickup trucks, and finds solutions that optimize travel time. Travel obeys one-way roads, avoids illegal turns, and follows other rules that are specific to cars. When you specify a start time, dynamic travel speeds based on traffic are used where it is available.",
        "impedanceAttributeName": "TravelTime",
        "simplificationToleranceUnits": "esriMeters",
        "uturnAtJunctions": "esriNFSBAtDeadEndsAndIntersections",
        "restrictionAttributeNames": [
        "Avoid Unpaved Roads",
        "Avoid Private Roads",
        "Driving an Automobile",
        "Through Traffic Prohibited",
        "Roads Under Construction Prohibited",
        "Avoid Gates",
        "Avoid Express Lanes",
        "Avoid Carpool Roads"
        ],
        "useHierarchy": true,
        "simplificationTolerance": 10,
        "timeAttributeName": "TravelTime",
        "distanceAttributeName": "Kilometers",
        "type": "AUTOMOBILE",
        "id": "FEgifRtFndKNcJMJ",
        "name": "Driving Time"
        },
    "Car Distance": {
        "attributeParameterValues": [{
                "attributeName": "Avoid Unpaved Roads",
                "parameterName": "Restriction Usage",
                "value": "AVOID_HIGH"
            },
            {
                "attributeName": "Avoid Private Roads",
                "parameterName": "Restriction Usage",
                "value": "AVOID_MEDIUM"
            },
            {
                "attributeName": "Driving an Automobile",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Through Traffic Prohibited",
                "parameterName": "Restriction Usage",
                "value": "AVOID_HIGH"
            },
            {
                "attributeName": "TravelTime",
                "parameterName": "Vehicle Maximum Speed (km/h)",
                "value": 0
            },
            {
                "attributeName": "Roads Under Construction Prohibited",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Avoid Gates",
                "parameterName": "Restriction Usage",
                "value": "AVOID_MEDIUM"
            },
            {
                "attributeName": "Avoid Express Lanes",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Avoid Carpool Roads",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            }
        ],
        "description": "Models the movement of cars and other similar small automobiles, such as pickup trucks, and finds solutions that optimize travel distance. Travel obeys one-way roads, avoids illegal turns, and follows other rules that are specific to cars.",
        "distanceAttributeName": "Kilometers",
        "id": "iKjmHuBSIqdEfOVr",
        "impedanceAttributeName": "Kilometers",
        "name": "Driving Distance",
        "restrictionAttributeNames": [
            "Avoid Unpaved Roads",
            "Avoid Private Roads",
            "Driving an Automobile",
            "Through Traffic Prohibited",
            "Roads Under Construction Prohibited",
            "Avoid Gates",
            "Avoid Express Lanes",
            "Avoid Carpool Roads"
        ],
        "simplificationTolerance": 10,
        "simplificationToleranceUnits": "esriMeters",
        "timeAttributeName": "TravelTime",
        "type": "AUTOMOBILE",
        "useHierarchy": true,
        "uturnAtJunctions": "esriNFSBAtDeadEndsAndIntersections"
    },
    "Truck Time": {
        "attributeParameterValues": [
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Use Preferred Truck Routes",
            "value": "PREFER_HIGH"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Unpaved Roads",
            "value": "AVOID_HIGH"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Private Roads",
            "value": "AVOID_MEDIUM"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Driving a Truck",
            "value": "PROHIBITED"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Roads Under Construction Prohibited",
            "value": "PROHIBITED"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Gates",
            "value": "AVOID_MEDIUM"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Express Lanes",
            "value": "PROHIBITED"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Carpool Roads",
            "value": "PROHIBITED"
            },
            {
            "parameterName": "Restriction Usage",
            "attributeName": "Avoid Truck Restricted Roads",
            "value": "AVOID_HIGH"
            },
            {
            "parameterName": "Vehicle Maximum Speed (km/h)",
            "attributeName": "TruckTravelTime",
            "value": 0
            }
        ],
        "description": "Models basic truck travel by preferring designated truck routes, and finds solutions that optimize travel time. Routes must obey one-way roads, avoid illegal turns, and so on. When you specify a start time, dynamic travel speeds based on traffic are used where it is available, up to the legal truck speed limit.",
        "impedanceAttributeName": "TruckTravelTime",
        "simplificationToleranceUnits": "esriMeters",
        "uturnAtJunctions": "esriNFSBNoBacktrack",
        "restrictionAttributeNames": [
        "Avoid Carpool Roads",
        "Avoid Express Lanes",
        "Avoid Gates",
        "Avoid Private Roads",
        "Avoid Truck Restricted Roads",
        "Avoid Unpaved Roads",
        "Driving a Truck",
        "Roads Under Construction Prohibited",
        "Use Preferred Truck Routes"
        ],
        "useHierarchy": true,
        "simplificationTolerance": 10,
        "timeAttributeName": "TruckTravelTime",
        "distanceAttributeName": "Kilometers",
        "type": "TRUCK",
        "id": "ZzzRtYcPLjXFBKwr",
        "name": "Trucking Time"
        },
    "Truck Distance": {
        "attributeParameterValues": [{
                "attributeName": "Use Preferred Truck Routes",
                "parameterName": "Restriction Usage",
                "value": "PREFER_HIGH"
            },
            {
                "attributeName": "Avoid Unpaved Roads",
                "parameterName": "Restriction Usage",
                "value": "AVOID_HIGH"
            },
            {
                "attributeName": "Avoid Private Roads",
                "parameterName": "Restriction Usage",
                "value": "AVOID_MEDIUM"
            },
            {
                "attributeName": "Driving a Truck",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Roads Under Construction Prohibited",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Avoid Gates",
                "parameterName": "Restriction Usage",
                "value": "AVOID_MEDIUM"
            },
            {
                "attributeName": "Avoid Express Lanes",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Avoid Carpool Roads",
                "parameterName": "Restriction Usage",
                "value": "PROHIBITED"
            },
            {
                "attributeName": "Avoid Truck Restricted Roads",
                "parameterName": "Restriction Usage",
                "value": "AVOID_HIGH"
            },
            {
                "attributeName": "TruckTravelTime",
                "parameterName": "Vehicle Maximum Speed (km/h)",
                "value": 0
            }
        ],
        "description": "Models basic truck travel by preferring designated truck routes, and finds solutions that optimize travel distance. Routes must obey one-way roads, avoid illegal turns, and so on.",
        "distanceAttributeName": "Kilometers",
        "id": "UBaNfFWeKcrRVYIo",
        "impedanceAttributeName": "Kilometers",
        "name": "Trucking Distance",
        "restrictionAttributeNames": [
            "Avoid Carpool Roads",
            "Avoid Express Lanes",
            "Avoid Gates",
            "Avoid Private Roads",
            "Avoid Truck Restricted Roads",
            "Avoid Unpaved Roads",
            "Driving a Truck",
            "Roads Under Construction Prohibited",
            "Use Preferred Truck Routes"
        ],
        "simplificationTolerance": 10,
        "simplificationToleranceUnits": "esriMeters",
        "timeAttributeName": "TruckTravelTime",
        "type": "TRUCK",
        "useHierarchy": true,
        "uturnAtJunctions": "esriNFSBNoBacktrack"
    }
}
